import { getAssignResourceDropdownV2Service } from "@/service/base.service";
import { showApiErrorToast } from "../utils/apiToastMessage";
import { useEffect, useState } from "react";
import type { LinkableGrade } from "../types/class.types";

function mapDropdownItems(
  items: { id: string; grade?: string; name?: string }[]
): LinkableGrade[] {
  return items.map((item) => ({
    id: item.id,
    name: item.grade ?? item.name ?? item.id,
  }));
}

/** Courses for the class form, scoped to the selected school (API v2). */
export function useSchoolCourseOptions(
  schoolId: string | undefined,
  enabled: boolean
) {
  const [grades, setGrades] = useState<LinkableGrade[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const id = schoolId?.trim();
    if (!enabled || !id) {
      setGrades([]);
      setLoading(false);
      return;
    }

    let cancelled = false;
    setLoading(true);

    getAssignResourceDropdownV2Service("course", { schoolId: id })
      .then(({ data }) => {
        if (!cancelled) {
          setGrades(mapDropdownItems(data.data ?? []));
        }
      })
      .catch((error) => {
        console.error("Failed to load school courses:", error);
        if (!cancelled) {
          setGrades([]);
          showApiErrorToast(error);
        }
      })
      .finally(() => {
        if (!cancelled) {
          setLoading(false);
        }
      });

    return () => {
      cancelled = true;
    };
  }, [schoolId, enabled]);

  return { grades, loading };
}
